import PicklistMetadata from "../PicklistMetadata";

// Picking what one element of a composite holds: a data type, by name, stored as the REVISION usid.
//
// THE REVISION, NOT THE LOGICAL TYPE, because that is what a field pins to. Offering the logical type
// would mean a field silently moving to a new definition the next time somebody revised it, which is
// exactly what pinning exists to prevent.
//
// The underlying component filters to the definition currently in force, so the list offers what a
// new field should be given rather than every version of everything.
class DataTypeRevisionPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "DataTypeRevision";
        this.static = false;
        this.enterpriseComponent = "DataTypeRevision";
        this.useRealm = false;
        // Searched on the server as the user types. The catalogue is small today and will not stay
        // that way -- a client-side filter is capped at the component's cache size, so it starts
        // silently omitting types the moment the list outgrows it.
        this.serverFilter = true;
        this.serverFilterOperator = "Contains";
        this.serverFilterLimit = 50;
        // A field's type is a foreign key. Free-typed text here would be a field typed as nothing.
        this.mustMatchOption = true;
        // RELEASED ONLY. A DRAFT is a definition somebody is still working on and a DEPRECATED one
        // is on the way out; neither should be offered to a field author, though both go on
        // resolving for anything already pinned to them -- which is a different question and the
        // reason this filter belongs here rather than on the component.
        this.searchSpecification = {"Status": "RELEASED"};
        this.sortSpecification = {"TypeName": "ASC"};
        this.typeField = "TypeName";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default DataTypeRevisionPicklistMetadata;
